import superManager from "./superManager";
import {modules, services} from "../gameEngine";
import {VIBRATE_TYPE} from "../services/miniGameContent/miniApp";

//
export interface SoundLocal {
    sound: boolean;
    vibrate: boolean;
    soundEffect: boolean;
}

export const SOUND_LOCAL_KEY: string = 'sound-manager-key';

export default class soundManager extends superManager {

    protected className: string = '声音管理';

    constructor() {
        super();
    }

    async loadManager(): Promise<boolean> {
        await super.loadManager();
        //
        this.onReadSetting();
        //
        return Promise.resolve(true);
    }

    //
    readonly soundResPath = "preload/sounds/";

    //声音开关
    private m_soundEnabled: boolean = true;
    //音效开关
    private m_soundEffectEnabled : boolean = true;
    //振动开头
    private m_vibrateEnabled: boolean = true;

    //获取声音的开关
    isSoundEnabled() {
        return this.m_soundEnabled;
    }

    isVibrateEnabled() {
        return this.m_vibrateEnabled;
    }

    setVibrateEnabled(enabled: boolean) {
        this.m_vibrateEnabled = enabled;
        this.onSetWriteSetting();
    }

    //设置声音的开关
    setSoundEnabled(enabled: boolean) {
        this.m_soundEnabled = enabled;
        // if (!this.isSoundEnabled()) {
        //     this.stopMusic();
        // }
        this.onSetWriteSetting();
        this.refreshMusicVolume();
    }

    setSoundEffect( enabled: boolean ){
        this.m_soundEffectEnabled = enabled;
        this.onSetWriteSetting();
    }

    private onSetWriteSetting() {
        let obj: SoundLocal = {
            sound: this.m_soundEnabled,
            vibrate: this.m_vibrateEnabled,
            soundEffect: this.m_soundEffectEnabled,

        }
        services().localStorageSrv.setStorage(SOUND_LOCAL_KEY, JSON.stringify(obj));
    }

    private onReadSetting() {
        let data = services().localStorageSrv.getStorage(SOUND_LOCAL_KEY);
        if (data) {
            let obj: SoundLocal = JSON.parse(data);
            this.m_soundEnabled = obj.sound;
            this.m_vibrateEnabled = obj.vibrate;
            this.m_soundEffectEnabled = obj.soundEffect;
            this.refreshMusicVolume();
        }
    }

    refreshMusicVolume() {
        cc.audioEngine.setMusicVolume(this.m_soundEnabled ? 1 : 0);
    }

    //播放振动
    playVibrate() {
        if (this.isVibrateEnabled()) {
            services().miniGameSrv.getAppApiInstance().vibrate(VIBRATE_TYPE.SHORT);
        }
    }

    /**
     * 播放背景音
     * gameBundle/preload/sound/aaa.mp3  ryw_playBGM("aaa")
     * @param name 具体名字 不带后缀.mp3
     */
    playMusic(name: string, bundleName: string = null) {
        // if (!this.isSoundEnabled())
        //     return;
        let url = this.getSoundUrl(name);
        //播放背景音乐
        let bundle = (bundleName && (cc.assetManager.getBundle(bundleName))) || modules().uiControlModule.getGameBundle();
        bundle.load(url, cc.AudioClip, function (err, clip: cc.AudioClip) {
            if (err) {
                cc.error(err);
                return;
            }
            cc.audioEngine.playMusic(clip, true);
        });
    }

    /**
     * 停止播放背景音乐
     */
    stopMusic() {
        cc.audioEngine.stopMusic();
    }

    /**
     * 播放音效
     * @param name 具体名字 不带后缀.mp3
     * @returns 异步返回 播放的ID soundId
     */
    async playSound(
        name: string
        , callb?: (clip: cc.AudioClip)=>void
        , bundleName: string = null,
        isLoop:boolean = false
    ): Promise<number> {

        return new Promise(resolve => {
            if ( !this.m_soundEffectEnabled ){
                return resolve(null);
            }
            // if (!this.isSoundEnabled()) {
            //     return resolve(null);
            // }

            if (name.trim() == '') {
                return resolve(null);
            }
            let url = this.getSoundUrl(name);
            //
            let bundle = (bundleName && (cc.assetManager.getBundle(bundleName))) || modules().uiControlModule.getGameBundle();
            bundle.load(url, cc.AudioClip, function (err, clip: cc.AudioClip) {
                if (err) {
                    cc.error(err);
                    return resolve(null);
                }
                try {
                    if (clip) {
                        if (callb) {
                            callb(clip);
                        }
                        let audioId = cc.audioEngine.play(clip, isLoop, 1);
                        resolve(audioId);
                    }
                } catch (e) {
                    console.warn('#89警告 存在音频问题', url);
                }
            });
        })
    }

    /**
     * 停止音效
     * @param soundId
     */
    stopSound(audioId: number) {
        cc.audioEngine.stop(audioId);
    }

    stopAllEffects() {
        cc.audioEngine.stopAllEffects();
    }


    getSoundUrl(name: string): string {
        let url = this.soundResPath + name;
        return url;
    }
}

























